import notificationTemplate from '../../../templates/common/notificationTemplate.html';

const NotificationView = Backbone.View.extend({
  // el: $(".notification-bar"),
  id: 'main-notification-block',
  className: 'notification-bar hide',

  initialize() {
  },

  events: {
    'click .close': 'close',
  },

  render(notification, type, withOverlay, callback, onClick, closedCallback, transparentOverlay, isWide) {
    let compiledTemplate;
    const that = this;

    if (notification && notification !== '') {
      const processedMessage = this.processMessage(notification);
      compiledTemplate = _.template(notificationTemplate, {
        notification: processedMessage,
        type,
      });

      this.$el.appendTo(document.body);
      this.$el.html(compiledTemplate);

      if (_.isFunction(callback)) {
        this.$el.slideDown(200, callback);
      }
    }

    if (_.isFunction(closedCallback)) {
      this.on('removed', () => {
        closedCallback();
        closedCallback = function () {};
      });
    }

    if (withOverlay) {
      $('#page').addClass('notify');
      if (transparentOverlay) {
        $('#page').addClass('notify-transparent');
      }
    }

    if (isWide) {
      this.$el.addClass('wide');
    }

    if (_.isFunction(onClick)) {
      this.$('p, .media').on('click', (e) => {
        onClick();
        that.close(e);
      });
    }
  },

  processMessage(messageData) {
    let sanitisedMessageData = '';

    if (_.isArray(messageData)) {
      sanitisedMessageData = _.map(messageData, (messageText) => this.sanitiseAndReplaceLinks(messageText));
    } else {
      sanitisedMessageData = this.sanitiseAndReplaceLinks(messageData);
    }

    return sanitisedMessageData;
  },

  sanitiseAndReplaceLinks(message) {
    const aTagsArray = [];

    if (message.includes('<a ') || message.includes('<p')) {
      const $preText = $(`<div>${message}</div>`);
      $preText.find('a,p').each((index, element) => {
        const $aTag = $(element);

        aTagsArray[index] = {
          index,
          text: $aTag.text(),
        };

        if ($aTag.attr('href')) {
          aTagsArray[index].href = $aTag.attr('href');
        }

        $aTag.replaceWith(`<span>*tag${index}</span>`);
      });
      let sanitisedText = $preText.text();

      aTagsArray.forEach((tagData) => {
        if (tagData.href) {
          sanitisedText = sanitisedText.replace(
            `*tag${tagData.index}`,
            `<a href="${tagData.href}" target="_blank">${tagData.text}</a>`,
          );
          return;
        }

        sanitisedText = sanitisedText.replace(
          `*tag${tagData.index}`,
          `<p>${tagData.text}</p>`,
        );
      });

      return sanitisedText;
    }

    return Utils.sanitise(message);
  },

  close() {
    this.$el.hide();
    $('#page').removeClass('notify').removeClass('notify-transparent');

    this.trigger('removed');
    // this.remove(); // removed as it was causing issues

    this.$el.removeClass('wide');
  },

  fadeOut() {
    const that = this;
    // ensure when alert is closed, parent is also closed.
    this.$el.fadeOut(() => {
      $('#page').removeClass('notify').removeClass('notify-transparent');

      that.trigger('removed');
      // that.remove(); // removed as it was causing issues

      that.$el.removeClass('wide');
    });
  },

  removeClasses() {
    $('#page').removeClass('notify').removeClass('notify-transparent');
  },

});

export default NotificationView;
